import { Api, RequestType, ResponseType, ErrorCode } from './define';
import TopPageDataApi, { Request as  TopPageApiRequest} from './top/top';
import GuidelinePageApi, { Request as GudelinePageQaRequest } from './guideline/guideline';
import CreatorPageApi, { Request as CreatorPageRequest }from './creators/creators';
import { LanguageUtils } from '../language/LanguageUtils';

// 通信共通ヘッダー 
const DefaultHeader:HeadersInit = {
    'Accept': 'application/json',
    'Accept-Encoding': 'gzip, deflate, br',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8',
    'Connection': 'keep-alive',
    'Language': LanguageUtils.getLanguage(),
}

const APIS = (() => {
    const callapi = async function<T extends RequestType, P extends ResponseType>(request:Api<T, P>): Promise<P>{
        let headers: HeadersInit = DefaultHeader;
        // フォームデータとして送るかどうか
        let body: any = {...request.request};

        // パラメータからtokenを削除
        if (body.token) {
            delete body.token;
        }

        // GETはパラメータをクエリに変換
        let url = (request.method === 'GET')
            ? `${request.url}?${new URLSearchParams(body).toString()}` 
            : request.url;

            try {
                var response = await fetch(
                    url,
                    {
                        method: request.method,
                        headers: headers,
                        body: (request.method === 'GET')? null: JSON.stringify(body),
                        credentials: 'include',
                        cache: 'no-cache',
                    });
    
                if (!response.ok) {
                    return Promise.reject({
                        httpStatusCode: response.status,
                        errorCode: -1,
                        errorHttpStatus: true,
                        errorMessage: `api: ${request.url} fail.\n${response.statusText}`
                    });
                }
                let responseObject = await response.json();
                let responseData = request.parseResponse(responseObject);
                if (responseData.errorCode) {
                    console.log("error", responseData);
                    responseData.httpStatusCode = 200;
                    responseData.errorHttpStatus = false;
                    return Promise.reject(responseData);
                }
                console.log("success", responseData)
                return responseData;
            } catch(e) {
                console.warn(`api request exception occur.\n${url}`, e);
                return Promise.reject({
                    httpStatusCode: -1,
                    errorCode: 0,
                    errorHttpStatus: false,
                    errorMessage: `api: ${request.url} exception occur.`
                });
            }
    }

return {
    topPage: async(request:TopPageApiRequest) => callapi(new TopPageDataApi(request)),
    guidelinePage: async(request:GudelinePageQaRequest) => callapi(new GuidelinePageApi(request)),
    creatorPage: async(request:CreatorPageRequest) => callapi(new CreatorPageApi(request)),
}
})();

export default APIS;